function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Icon } from '@doordash/design-language';
import { IconButton } from '@doordash/component-button';
import { IconContainer } from './styles';
import PropTypes from 'prop-types';
import React from 'react';
import { Sides } from './constants';

var ConditionalIconButton = function ConditionalIconButton(_ref) {
  var onClick = _ref.onClick,
      type = _ref.type,
      accessibilityLabel = _ref.accessibilityLabel,
      renderIconSpacer = _ref.renderIconSpacer,
      size = _ref.size,
      sharedColor = _ref.sharedColor,
      color = _ref.color,
      iconAlignment = _ref.iconAlignment,
      side = _ref.side,
      tag = _ref.tag,
      target = _ref.target,
      href = _ref.href,
      columnProps = _objectWithoutProperties(_ref, ["onClick", "type", "accessibilityLabel", "renderIconSpacer", "size", "sharedColor", "color", "iconAlignment", "side", "tag", "target", "href"]);

  var shouldBeButton = !!onClick;
  var Component = shouldBeButton ? IconButton : Icon;
  var props = shouldBeButton ? {
    size: size || IconButton.Sizes.Medium,
    type: IconButton.Types.Plain,
    iconType: type,
    accessibilityLabel: accessibilityLabel,
    onClick: onClick,
    tag: tag,
    target: target,
    href: href
  } : {
    size: size || Icon.Sizes.Medium,
    type: type,
    accessibilityLabel: accessibilityLabel,
    color: color || sharedColor
  };
  return /*#__PURE__*/React.createElement(IconContainer, {
    renderIconSpacer: renderIconSpacer,
    onClick: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    onKeyDown: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    side: side,
    iconAlignment: iconAlignment,
    shouldBeButton: shouldBeButton,
    size: size,
    columnProps: columnProps
  }, /*#__PURE__*/React.createElement(Component, props));
};

ConditionalIconButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOfType([PropTypes.oneOf(Object.values(IconButton.Types)), PropTypes.oneOf(Object.values(Icon.Types))]),
  renderIconSpacer: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  size: PropTypes.oneOf(Object.values(Icon.Sizes)),
  sharedColor: PropTypes.oneOf(Object.values(Icon.Colors)),
  color: PropTypes.oneOf(Object.values(Icon.Colors)),
  iconAlignment: PropTypes.any,
  side: PropTypes.oneOf(Object.values(Sides)),
  tag: IconButton.propTypes.tag,
  target: IconButton.propTypes.target,
  href: IconButton.propTypes.href
};
export default ConditionalIconButton;